export default {
  showSlide: 'Zobraziť snímku {number} z {count}',
};
